export const ListingContactMethod = {
  Phone: 'PHONE',
  DirectMessage: 'DIRECT_MESSAGE',
  Whatsapp: 'WHATSAPP',
} as const;

export type ListingContactMethodValue =
  (typeof ListingContactMethod)[keyof typeof ListingContactMethod];

export const LISTING_CONTACT_METHOD_ORDER: ListingContactMethodValue[] = [
  ListingContactMethod.Phone,
  ListingContactMethod.DirectMessage,
  ListingContactMethod.Whatsapp,
];

export const WHATSAPP_DISCLOSURE_POLICY_SLUG = 'whatsapp-iletisim-bildirimi';

export const WHATSAPP_DISCLOSURE_TEXT =
  'WhatsApp üzerinden gerçekleşen iletişimin SadeceBilgisayar platformu dışında yürütüldüğünü, platformun bu mesajların içeriğini görüntüleyemediğini veya denetleyemediğini ve bu iletişim kanalının kullanımından doğabilecek riskleri anladığımı kabul ediyorum.';
